// extracted by mini-css-extract-plugin
export default {"title":"pVCJd","desktop":"GNodM","tablet":"GtBtE","mobile":"wAHTK"};